import { useState, useEffect } from "react";
const API = "https://prestijcrm.duckdns.org/api";
const kart = (baslik, deger, renk) => (
  <div style={{background:"#1e293b",borderRadius:"10px",padding:"24px",flex:1,minWidth:"150px"}}>
    <div style={{color:"#94a3b8",fontSize:"14px",marginBottom:"8px"}}>{baslik}</div>
    <div style={{color:renk||"#3b82f6",fontSize:"32px",fontWeight:"700"}}>{deger}</div>
  </div>
);
export default function Dashboard() {
  const [stats, setStats] = useState({musteriler:0,sicak:0,ilanlar:0,buAy:0});
  useEffect(() => {
    const token = localStorage.getItem("token");
    const h = { Authorization: `Bearer ${token}` };
    fetch(`${API}/customers`, { headers: h }).then(r=>r.json()).then(d=>{
      const buAy = d.customers?.filter(m=>{
        const t = new Date(m.created_at); const n = new Date();
        return t.getMonth()===n.getMonth() && t.getFullYear()===n.getFullYear();
      }).length || 0;
      const sicak = d.customers?.filter(m=>m.status==="sicak").length || 0;
      setStats(s=>({...s, musteriler: d.total||0, sicak, buAy}));
    }).catch(()=>{});
    fetch(`${API}/ilanlar`, { headers: h }).then(r=>r.json()).then(d=>{
      setStats(s=>({...s, ilanlar: d.total||0}));
    }).catch(()=>{});
  }, []);
  return (
    <div style={{padding:"32px",color:"white"}}>
      <h2 style={{marginBottom:"24px",fontSize:"22px"}}>Dashboard</h2>
      <div style={{display:"flex",gap:"16px",flexWrap:"wrap",marginBottom:"32px"}}>
        {kart("Toplam Müşteri", stats.musteriler, "#3b82f6")}
        {kart("Sıcak Müşteri", stats.sicak, "#ef4444")}
        {kart("Bu Ay", stats.buAy, "#10b981")}
        {kart("Toplam İlan", stats.ilanlar, "#f59e0b")}
      </div>
    </div>
  );
}
